import Vue from 'vue';
import Vuex from 'vuex';

import AuthenticationModule from './authentication';
import PackFrontalModule from './packfrontal';
import ViewSharedProjectModule from './viewSharedProject';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    esVisible: false
  },
  mutations:{
    cerrar(state){
      state.esVisible = false;
    },
    abrir(state){
      state.esVisible = true;
    },
  },
  actions: {
    accionCerrar({commit}){
      commit('cerrar');
    },
    accionAbrir({commit}){
      commit('abrir');
    },
  },
  modules: {
    authentication: AuthenticationModule,
    packfrontal: PackFrontalModule,
    viewSharedProject: ViewSharedProjectModule,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js